// extracted by mini-css-extract-plugin
module.exports = {"root":"HeaderDebts_root__2U8-t"};